export var SeatSelectionRuleName;
(function (SeatSelectionRuleName) {
    SeatSelectionRuleName["CannotLeaveGapsBetweenSelectedSeats"] = "CannotLeaveGapsBetweenSelectedSeats";
    SeatSelectionRuleName["CannotLeaveSingleSeatGapFromAisle"] = "CannotLeaveSingleSeatGapFromAisle";
    SeatSelectionRuleName["CannotLeaveSingleSeatGapFromUnavailableSeat"] = "CannotLeaveSingleSeatGapFromUnavailableSeat";
    SeatSelectionRuleName["MustFillSofaSeats"] = "MustFillSofaSeats";
    SeatSelectionRuleName["MustSelectAssociatedWheelchairSeat"] = "MustSelectAssociatedWheelchairSeat";
    SeatSelectionRuleName["MustRespectSeatSelectionLimits"] = "MustRespectSeatSelectionLimits";
})(SeatSelectionRuleName || (SeatSelectionRuleName = {}));
